import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ContentProvider } from "@/content/ContentContext";
import { LanguageProvider } from "@/i18n/LanguageContext";
import ScrollToTop from "@/components/ScrollToTop";
import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Manifesto from "@/components/landing/Manifesto";
import Products from "@/components/landing/Products";
import Spotlight from "@/components/landing/Spotlight";
import Stats from "@/components/landing/Stats";
import Testimonials from "@/components/landing/Testimonials";
import CropGuide from "@/components/landing/CropGuide";
import News from "@/components/landing/News";
import DealerCTA from "@/components/landing/DealerCTA";
import EnquiryForm from "@/components/landing/EnquiryForm";
import ProductDetailPage from "@/pages/ProductDetailPage";
import ModelPage from "@/pages/ModelPage";
import CropAdvisorPage from "@/pages/CropAdvisorPage";
import ChatAssistant from "@/components/landing/ChatAssistant";
import WhatsAppButton from "@/components/landing/WhatsAppButton";
import FittingsPage from "@/pages/FittingsPage";
import TeamSection from "@/components/landing/TeamSection";
import AppDownload from "@/components/landing/AppDownload";
import ProductsOffer from "@/components/landing/ProductsOffer";
import AdminLogin from "@/pages/admin/Login";
import AdminDashboard from "@/pages/admin/Dashboard";
import Certifications from "@/components/landing/Certifications";
import { HistoryPage, LeadershipPage, SegmentsPage, SustainabilityPage } from "@/pages/company";

const Home = () => (
  <>
    <Hero />
    <Marquee />
    <Manifesto />
    <ProductsOffer />
    <Spotlight />
    <Stats />
    <Certifications />
    <DealerCTA />
    <AppDownload />
  </>
);
const ProductsPage = () => <Products />;
const AboutPage = () => (
  <>
    <Manifesto />
    <TeamSection />
  </>
);
const StoriesPage = () => <Testimonials />;
const CropsPage = () => <CropGuide />;
const UpdatesPage = () => <News />;
const ContactPage = () => <EnquiryForm />;

function Layout() {
  return (
    <>
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
      <ChatAssistant />
      <WhatsAppButton />
    </>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      smoothWheel: true,
    });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <ContentProvider>
      <LanguageProvider>
        <div className="grain relative min-h-screen bg-forest font-body text-cream">
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/products" element={<ProductsPage />} />
                <Route path="/products/:id" element={<ProductDetailPage />} />
                <Route path="/products/:id/models/:slug" element={<ModelPage />} />
                <Route path="/fittings" element={<FittingsPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/history" element={<HistoryPage />} />
                <Route path="/leadership" element={<LeadershipPage />} />
                <Route path="/sustainability" element={<SustainabilityPage />} />
                <Route path="/segments" element={<SegmentsPage />} />
                <Route path="/crop-advisor" element={<CropAdvisorPage />} />
                <Route path="/stories" element={<StoriesPage />} />
                <Route path="/crops" element={<CropsPage />} />
                <Route path="/updates" element={<UpdatesPage />} />
                <Route path="/contact" element={<ContactPage />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </div>
      </LanguageProvider>
    </ContentProvider>
  );
}

export default App;
